"use strict";

/* eslint-disable no-console */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Log = exports.LogLevel = void 0;
// intentionally spaced for formatting
const DEBUG = ' DEBUG ';
const _INFO = '  INFO ';
const _WARN = '  WARN ';
const ERROR = ' ERROR ';
function addTag(args) {
  args.unshift('[Statsig]');
  return args; // ['[Statsig]', ...args];
}
exports.LogLevel = {
  None: 0,
  Error: 1,
  Warn: 2,
  Info: 3,
  Debug: 4
};
class Log {
  static info() {
    if (Log.level >= exports.LogLevel.Info) {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      console.info(_INFO, ...addTag(args));
    }
  }
  static debug() {
    if (Log.level >= exports.LogLevel.Debug) {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      console.debug(DEBUG, ...addTag(args));
    }
  }
  static warn() {
    if (Log.level >= exports.LogLevel.Warn) {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      console.warn(_WARN, ...addTag(args));
    }
  }
  static error() {
    if (Log.level >= exports.LogLevel.Error) {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      console.error(ERROR, ...addTag(args));
    }
  }
}
exports.Log = Log;
Log.level = exports.LogLevel.Warn;